import { render, staticRenderFns } from "./PartInputTags.vue?vue&type=template&id=79480312&scoped=true&"
import script from "./PartInputTags.vue?vue&type=script&lang=js&"
export * from "./PartInputTags.vue?vue&type=script&lang=js&"
import style0 from "./PartInputTags.vue?vue&type=style&index=0&id=79480312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79480312",
  null
  
)

export default component.exports